// extracted by mini-css-extract-plugin
export default {"caption":"caption--rBQNI","caption--sm":"caption--sm--EQTdx","caption--up-sm":"caption--up-sm--scee5"};